import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {},
    template: `
        <div class="heading01 heading01b">
            <h2>{{ 'skill.Edit skill properties' | translate }}</h2>
            <ul class="actions01">
                <li class="primary">
                    <a class="btn main" ng-click="vm.formApi.save()">
                        {{ 'general.Save changes' | translate }}
                    </a>
                </li>
                <li class="danger">
                    <a class="btn bordered02" ng-click="vm.formApi.delete()">
                        {{ 'general.Delete' | translate }}
                    </a>
                </li>
                <li>
                    <a class="btn bordered02"
                       ui-sref="authorized.user.skill.list.skill()">
                        {{ 'general.Cancel' | translate }}
                    </a>
                </li>
            </ul>
        </div>
        <user-skill-form-skill
            mode="edit"
            skill-id="vm.$stateParams.id"
            api="vm.formApi">
        </user-skill-form-skill>
    `
})
export default class {
    constructor ($stateParams) {
        this.$stateParams = $stateParams;
        this.formApi = {}; // filled by child
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/skill/edit/skill/index.js